import { Backdrop, Stack } from '@mui/material'
import Box from '@mui/material/Box/Box'
import CssBaseline from '@mui/material/CssBaseline/CssBaseline'

import { useShowExpiredNotification } from 'hook/useShowExiperdLicenseNotification'
import { useEffect, useRef, useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../components/Header'
import NotificationSide from '../components/notifications/NotificationSide'
import Notification from '../components/shared/Notification'
import Sidebar from '../ui/sidebar/Sidebar'

import useScrollToTop from 'hook/useScrollToTop'
import { useWebSocket } from 'hook/useWebsocket'
import axAPI from '../httpConfig'
import { useAppSelector } from '../store/hooks'

const MainPage = () => {
	const [openNotifications, setOpenNotifications] = useState(false)
	const [countNotif, setCountNotif] = useState(0)
	const { userData } = useAppSelector(store => store.userReducer)
	const messages = useAppSelector(
		state => state.websocketReducer.messageForNotifications,
	)

	useScrollToTop()
	useWebSocket()
	useShowExpiredNotification({ userData })
	const notificationButtonRef = useRef(null)
	useEffect(() => {
		if (messages !== null) {
			setCountNotif(prevState => prevState + 1)
		}
	}, [messages])

	useEffect(() => {
		axAPI.get('notifications/count').then(response => {
			setCountNotif(response.data.new_count)
		})
	}, [])

	return (
		<>
			<Box sx={{ display: 'flex', position: 'relative' }}>
				<CssBaseline />
				<Sidebar
					setOpenNotifications={setOpenNotifications}
					countNotif={countNotif}
					openNotifications={openNotifications}
					notificationButtonRef={notificationButtonRef}
				/>
				<Stack direction='column' width='100%' sx={{ minWidth: 0 }}>
					<Header />
					<Box
						component='main'
						sx={{
							flexGrow: 1,
							minWidth: 0,
							bgcolor: 'background.default',
						}}
					>
						<Outlet />
					</Box>
				</Stack>
			</Box>
			<Backdrop
				open={openNotifications}
				transitionDuration={400}
				sx={{
					zIndex: 500,
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
				}}
			/>
			<NotificationSide
				openNotifications={openNotifications}
				setOpenNotifications={setOpenNotifications}
				countNotif={countNotif}
				setCountNotif={setCountNotif}
				notificationButtonRef={notificationButtonRef}
			/>
			<Notification />
		</>
	)
}

export default MainPage
